import { render, staticRenderFns } from "./AddEditQuestion.vue?vue&type=template&id=13de01c6&"
import script from "./AddEditQuestion.vue?vue&type=script&lang=js&"
export * from "./AddEditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddEditQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports